(() => {
  const instances = new Map();
  function initialize(root = document) {
    root.querySelectorAll('[data-announcement-carousel]').forEach(el => {
      if (instances.has(el)) return;
      const slides = [...el.querySelectorAll('[data-announcement-slide]')];
      if (slides.length < 2) return;
      const track = el.querySelector('[data-announcement-track]');
      const pause = el.querySelector('[data-announcement-pause]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, timer, hovering = false, focused = false;
      let paused = el.dataset.autoplay !== 'true' || reduced.matches;
      function show(next) {
        index = (next + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;
        slides.forEach((slide, i) => {
          slide.inert = i !== index;
          slide.setAttribute('aria-hidden', String(i !== index));
        });
      }
      function stop() { clearInterval(timer); }
      function start() {
        stop();
        if (!paused && !hovering && !focused && !document.hidden)
          timer = setInterval(() => show(index + 1), Number(el.dataset.interval) || 4000);
      }
      function updatePause() {
        pause.textContent = paused ? '▶' : 'Ⅱ';
        pause.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      }
      el.querySelector('[data-announcement-prev]').addEventListener('click', () => { show(index - 1); start(); });
      el.querySelector('[data-announcement-next]').addEventListener('click', () => { show(index + 1); start(); });
      pause.addEventListener('click', () => { paused = !paused; updatePause(); start(); });
      el.addEventListener('mouseenter', () => { hovering = true; stop(); });
      el.addEventListener('mouseleave', () => { hovering = false; start(); });
      el.addEventListener('focusin', () => { focused = true; stop(); });
      el.addEventListener('focusout', event => { if (!el.contains(event.relatedTarget)) { focused = false; start(); } });
      const visibility = () => document.hidden ? stop() : start();
      const motion = () => { if (reduced.matches) { paused = true; updatePause(); stop(); } };
      document.addEventListener('visibilitychange', visibility);
      reduced.addEventListener('change', motion);
      instances.set(el, { show, stop, destroy() { stop(); document.removeEventListener('visibilitychange', visibility); reduced.removeEventListener('change', motion); } });
      updatePause(); start();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => instances.forEach((api, el) => { if (event.target.contains(el)) { api.destroy(); instances.delete(el); } }));
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-announcement-slide]');
    if (!slide) return;
    const el = slide.closest('[data-announcement-carousel]'), api = instances.get(el);
    if (api) { api.stop(); api.show([...el.querySelectorAll('[data-announcement-slide]')].indexOf(slide)); }
  });
})();
